import React, { useEffect, useCallback, useState} from 'react';
import {setHicDialog} from 'actions/index.js';
import Modal from 'react-bootstrap/Modal';
import {connect} from 'react-redux';
import { Button } from 'reactstrap';

const HicDialog = ({setHicDialog, hicDialog}) => { 
    let url = "https://zequencer.io/ipfs/" + hicDialog.page;
    const downloadZip = useCallback(() => {
        window.open("https://zequencer.io/ipfs/" + hicDialog.zip);
    }, [hicDialog]);

    return (
        <Modal dialogClassName="hic-modal preset-modal" show={true} onHide={() => setHicDialog(undefined)}>
          <Modal.Header closeButton>
            <Modal.Title>Hicetnunc Assets</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            Check this url to see if your NFT is showing correctly
            <div className="ipfs-url">
            <a href={url} target="_blank">{url}</a>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={downloadZip}>
              Download Zip
            </Button>
          </Modal.Footer>
        </Modal>
    );
}

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
      setHicDialog: x => dispatch(setHicDialog(x))
  };

};

export default connect(mapStateToProps, mapDispatchToProps)(HicDialog);
